import { useMediaQuery } from 'react-responsive';
import styles from './StudentHeroSegment.module.scss';

interface Props {
  home?: boolean;
  confirm?: boolean;
  featureStory?: boolean;
  backgroundImage?: string;
  children: React.ReactNode;
}

const StudentHeroSegment = ({ home, featureStory, children, backgroundImage, confirm }: Props): JSX.Element => {
  const getSegmentHeight = () => {
    if (home) return '370px';
    if (confirm) return '490px';
    if (isSmall) return '608px';
    return '490px';
  };
  const isSmall = useMediaQuery({ maxWidth: 576 });
  return (
    <div
      className={styles.container}
      style={{
        height: getSegmentHeight(),
        backgroundColor: featureStory ? '#e7f4f7' : 'rgba(255, 99, 25, 0.1)',
      }}
    >
      {children}
      <img src={backgroundImage} className={home || confirm ? styles.toDosHome : styles.toDosActivity} alt='' />
    </div>
  );
};

export default StudentHeroSegment;
